
















































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import ModalFiltroPorProcedimentoIncluir from './ModalFiltroPorProcedimentoIncluir.vue'

@Component({
  components: {
    ModalFiltroPorProcedimentoIncluir,
  },
})
export default class FiltroPorProcedimento extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadProcedimentos: boolean = false
  get loadingProcedimentos() { return this.loadProcedimentos }
  set loadingProcedimentos(value: boolean) { this.loadProcedimentos = value }

  get procedimentosHeader() {
    return [
      { text: 'Incluído por', value: 'createdByNome', sortable: false, align: 'center' },
      { text: 'Incluído em', value: 'createdOn', sortable: false, align: 'center' },
      { text: 'Código', value: 'codigo', sortable: false, align: 'center' },
      { text: 'Descrição', value: 'descricao', sortable: false, align: 'center' },
      { text: 'Ações', value: '', sortable: false, align: 'center' },
    ]
  }

  get procedimentos() { return this.getRegrasDeCalculoStore.filtroPorProcedimentoList }
  get paginacaoProcedimento() { return this.getRegrasDeCalculoStore.paginacaoFiltroPorProcedimento }
  procedimentoDebounce = _.debounce(param => this.getRegrasDeCalculoStore.getFiltroPorProcedimentoList(param), 700)

  async updatePaginationPlano(pagination: DataTablePagination) {
    if (!this.getRegrasDeCalculoStore.modal.regraDeCalculo) return
    this.loadingProcedimentos = true
    this.procedimentoDebounce(pagination)
    this.loadingProcedimentos = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeleteProcedimento: string = ''
  get loadingDeletarProcedimento() { return this.loadDeleteProcedimento }
  set loadingDeletarProcedimento(value: string) { this.loadDeleteProcedimento = value }

  get showModal() { return this.getRegrasDeCalculoStore.modal.filtroProcedimento }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'filtroProcedimento', value }) }

  async removeProcedimento(id: string) {
    this.loadingDeletarProcedimento = id
    const request = await this.getRegrasDeCalculoStore.deleteFiltroPorProcedimento(id)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarProcedimento = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarProcedimento = ''
  }
}
